export default [
  {
    path: "/operations/new-booking",
    name: "BookingNew",
    component: () => import("@/views/3pl/Operations/Bookings/NewBooking.vue"),
  },
  {
    path: "/operations/edit-booking/:bookingId",
    name: "BookingEdit",
    component: () => import("@/views/3pl/Operations/Bookings/EditBooking.vue"),
  },
  {
    path: "/operations/booking",
    name: "BookingsHome",
    component: () => import("@/views/3pl/Operations/Bookings/Home.vue"),
  },
  {
    path: "/operations/booking/update-status",
    name: "BookingsUpdateStatus",
    component: () => import("@/views/3pl/Operations/Bookings/UpdateStatus.vue"),
  },
  {
    path: "/3pl/dashboard",
    name: "3plDashboard",
    component: () => import("@/views/3pl/Operations/Bookings/Home.vue"),
  },
  {
    path: "/3pl/scheduled-bookings",
    name: "3plScheduledBookings",
    component: () =>
      import(
        "@/components/3pl/Operations/Bookings/Home/ScheduledShipments.vue"
      ),
  },
  {
    path: "/operations/bookings",
    name: "BookingsList",
    component: () => import("@/views/3pl/Operations/Bookings/BookingsList.vue"),
  },
  {
    path: "/operations/bookings/booking-summary/:id",
    name: "BookingSummary",
    component: () =>
      import("@/views/3pl/Operations/Bookings/BookingSummary.vue"),
  },
  {
    path: "/operations/bookings/:id",
    name: "BookingTimeline",
    component: () =>
      import("@/views/3pl/Operations/Bookings/ShipmentTimeline.vue"),
  },

  {
    path: "/operations/consolidation",
    name: "ConsolidationHome",
    component: () => import("@/views/3pl/Operations/Consolidation/Home.vue"),
  },
  {
    path: "/operations/consolidation/new",
    name: "NewConsolidation",
    component: () =>
      import("@/views/3pl/Operations/Consolidation/NewConsolidation.vue"),
  },
    {
    path: "/operations/consolidationNew/new",
    name: "NewConsolidationNew",
    component: () =>
      import("@/views/3pl/Operations/consolidation-new/Home.vue"),
  },
    {
    path: "/operations/manifest-new/:id",
    name: "NewManifest",
    component: () =>
      import("@/views/3pl/Operations/consolidation-new/manifest.vue"),
  },
  {
    path: "/operations/consolidation/view-details/:id",
    name: "ConsolidationDetails",
    component: () =>
      import("@/views/3pl/Operations/Consolidation/ViewDetails.vue"),
  },
  {
    path: "/operations/consolidation/update-status",
    name: "ConsolidationStatus",
    component: () =>
      import("@/views/3pl/Operations/Consolidation/UpdateStatus.vue"),
  },
  {
    path: "/operations/dispatch",
    name: "Dispatch",
    component: () => import("@/views/3pl/Operations/Dispatch/Dispatch.vue"),
  },
  {
    path: "/operations/dispatch/manifest/:dispatchID",
    name: "DispatchManifest",
    component: () => import("@/views/3pl/Operations/Dispatch/Manifest.vue"),
  },
  {
    path: "/operations/dispatch/update-status",
    name: "ManifestUpdateStatus",
    component: () => import("@/views/3pl/Operations/Dispatch/UpdateStatus.vue"),
  },
  {
    path: "/operations/dispatch/shipment-timeline/:dispatchID",
    name: "DispatchTimeline",
    component: () =>
      import("@/views/3pl/Operations/Dispatch/ShipmentTimeline.vue"),
  },
  {
    path: "/operations/requests",
    name: "Requests",
    component: () =>
      import("@/views/3pl/Operations/Requests/AllRequests.vue"),
  },
  {
    path: "/operations/booking/requests",
    name: "BookingRequests",
    component: () =>
      import("@/views/3pl/Operations/Requests/BookingRequests.vue"),
  },
  {
    path: "/3pl/booking-direction",
    name: "Booking3plDirection",
    component: () => import("@/views/3pl//Operations/Bookings/BookingDirection.vue"),
  },
];
